import React from "react";
import { useLanguage } from "./LanguageContext";

const LanguageModal = ({ onClose }) => {
  const { setLanguage } = useLanguage();

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-lightBrown p-6 rounded-lg shadow-lg text-center w-80">
        <h2 className="text-xl font-semibold mb-4 avenir">Select Language</h2>
        <div className="space-x-4">
          <button
            className="bg-red-500 text-white shadow-lg hover:bg-red-600 transition duration-300 font-semibold py-2 px-4 rounded"
            onClick={() => handleLanguageChange("en")}
          >
            English
          </button>
          <button
            className="bg-red-500 text-white shadow-lg hover:bg-red-600 transition duration-300 font-semibold py-2 px-4 rounded"
            onClick={() => handleLanguageChange("vi")}
          >
            Tiếng Việt
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
